import React from 'react';
import { Book, Headphones, Star, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { bookHighlights } from '../mockData';

const BookSection = () => {
  return (
    <section id="libro" className="py-24 bg-gradient-to-br from-cream via-white to-lilac-light">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-golden/10 text-golden text-sm font-medium tracking-wider rounded-full mb-4">
            LIBRO Y AUDIOLIBRO
          </span>
          <h2 className="text-4xl sm:text-5xl font-serif font-light text-charcoal mb-6">
            Mujer, Construye tu Libertad Financiera
          </h2>
          <p className="text-lg text-charcoal/70 max-w-3xl mx-auto leading-relaxed">
            Guía para vivir en paz financiera y lograr tus metas sin depender de nadie
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Book Image */}
          <div className="relative order-2 lg:order-1">
            <a 
              href="http://go.viubux.com/kari-rojas" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-300 max-w-md mx-auto cursor-pointer"
              data-testid="book-cover-link"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_mujer-invierte/artifacts/422oiv10_PORTADA%20-%20MCLF%20-%20KARI%20ROJAS.png"
                alt="Portada del Libro - Mujer Construye tu Libertad Financiera"
                className="w-full h-full object-cover"
              />
            </a>
            <div className="absolute -top-8 -left-8 w-64 h-64 bg-golden/10 rounded-full blur-3xl -z-10"></div>
          </div>

          {/* Content */}
          <div className="space-y-8 order-1 lg:order-2">
            <div className="space-y-6">
              <h3 className="text-2xl font-serif text-charcoal">
                Descubre el camino hacia tu independencia financiera
              </h3>
              
              <div className="space-y-4">
                {bookHighlights.map((highlight, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-golden/20 flex items-center justify-center mt-1">
                      <Star className="text-golden" size={14} fill="currentColor" />
                    </div>
                    <p className="text-charcoal/80">{highlight}</p>
                  </div>
                ))}
              </div>

              <Card className="p-6 bg-white border-cream-dark">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <Book className="text-golden" size={32} />
                  </div>
                  <div>
                    <h4 className="font-medium text-charcoal mb-2">Formato Libro</h4>
                    <p className="text-sm text-charcoal/60">
                      Disponible en formato físico y digital. Incluye ejercicios prácticos y plantillas descargables.
                    </p>
                  </div>
                </div>
              </Card>

              <Card className="p-6 bg-white border-cream-dark">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <Headphones className="text-golden" size={32} />
                  </div>
                  <div>
                    <h4 className="font-medium text-charcoal mb-2">Formato Audiolibro</h4>
                    <p className="text-sm text-charcoal/60">
                      Escucha en cualquier momento. Narrado por Kari Rojas, perfecto para escuchar mientras viajas.
                    </p>
                  </div>
                </div>
              </Card>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => window.open('http://go.viubux.com/kari-rojas', '_blank')}
                className="bg-golden hover:bg-golden-dark text-white px-8 py-6 text-base font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
                data-testid="buy-book-btn"
              >
                Comprar Ahora
                <ArrowRight className="ml-2" size={20} />
              </Button>
              
              <Button 
                onClick={() => window.open('https://app.viubux.com/subscribe/2251799918000068?signature=d8a9e4de8d156162eee370104487ecc3d015091280aaa5271b2859f286ee11f4', '_blank')}
                className="bg-gradient-to-r from-purple-600 to-pink-500 hover:from-purple-700 hover:to-pink-600 text-white px-8 py-6 text-base font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
                data-testid="subscribe-viubux-btn"
              >
                <Headphones className="mr-2" size={20} />
                Suscríbete a mi Canal
              </Button>
            </div>
            
            <p className="text-sm text-charcoal/60">
              🎧 En mi canal de Viubux encontrarás: audiolibro, libro electrónico, curso y consejos prácticos en audio
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookSection;
